<script lang="ts">
	export { classes as class };
	let classes = 'w-6 h-6';
</script>

<svg
	class={classes}
	width="24"
	height="24"
	viewBox="0 0 24 24"
	fill="none"
	xmlns="http://www.w3.org/2000/svg"
>
	<path
		fill-rule="evenodd"
		clip-rule="evenodd"
		d="M5.367 3.477C7.205 3.235 9.609 3 12 3s4.795.235 6.633.477C19.993 3.656 21 4.84 21 6.279v7.12a2 2 0 0 1-1.717 1.979l-2.654.38c-1.405.2-2.675.99-3.444 2.21A66 66 0 0 0 12 19.919a66 66 0 0 0-1.185-1.95 4.872 4.872 0 0 0-3.444-2.21l-2.654-.38A2 2 0 0 1 3 13.398V6.28c0-1.44 1.008-2.623 2.367-2.802ZM12 1c-2.51 0-5.008.246-6.894.494C2.685 1.812 1 3.905 1 6.279v7.12a4 4 0 0 0 3.434 3.959l2.654.379a2.872 2.872 0 0 1 2.035 1.298c.65 1.032 1.464 2.375 1.983 3.412a1 1 0 0 0 1.788 0c.519-1.037 1.333-2.38 1.983-3.412a2.872 2.872 0 0 1 2.035-1.298l2.654-.38A4 4 0 0 0 23 13.399V6.28c0-2.374-1.685-4.467-4.106-4.785C17.008 1.246 14.51 1 12 1Zm3.207 5.293a1 1 0 0 1 0 1.414L13.414 9.5l1.793 1.793a1 1 0 0 1-1.414 1.414L12 10.914l-1.793 1.793a1 1 0 0 1-1.414-1.414L10.586 9.5 8.793 7.707a1 1 0 0 1 1.414-1.414L12 8.086l1.793-1.793a1 1 0 0 1 1.414 0Z"
		fill="currentColor"
	/>
</svg>
